export const enum HTTP_CODES {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
}
